module.exports = __webpack_public_path__ + "static/media/tech-specifications.3b1107b2.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/tech-specifications.pdf
// module id = 144
// module chunks = 0